<template>
  <div class>asdas</div>
</template>

<script>
import axios from 'axios'

const instance = axios.create({
  baseURL: "https://app.rivalry.com/api/v1/",
  withCredentials: false,
  proxy:{
      'host':'rivalry.com',
  },
  headers: {
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
});
export default {
    mounted(){
        instance.get('https://app.rivalry.com/api/v1/tournaments/671')
        .then(resp =>{
            console.log(resp)
        })
    }
}
</script>

<style>
</style>